<div class="tap-alert" [ngClass]="'tap-alert--' + type" role="alert" aria-live="polite">
  <div class="tap-alert__header">
    <mat-icon class="tap-alert__icon">{{ iconName }}</mat-icon>
    <span *ngIf="title" class="tap-alert__title">{{ title | translate }}</span>
    <span class="tap-alert__spacer"></span>
    <button
      *ngIf="dismissible"
      mat-icon-button
      class="tap-alert__dismiss"
      (click)="onDismiss()"
      aria-label="Dismiss"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p *ngIf="message" class="tap-alert__message">{{ message | translate: messageParams }}</p>
  <ul *ngIf="items?.length" class="tap-alert__list">
    <li *ngFor="let item of items">{{ item | translate }}</li>
  </ul>
  <ul *ngIf="linkedItems?.length" class="tap-alert__list">
    <li *ngFor="let item of linkedItems">
      <button *ngIf="item.fieldId; else plainText" class="tap-alert__field-link" (click)="onItemClick(item.fieldId)">
        {{ item.messageKey | translate: item.translationParams }}
      </button>
      <ng-template #plainText>{{ item.messageKey | translate: item.translationParams }}</ng-template>
    </li>
  </ul>
  <ng-content></ng-content>
</div>
